import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { array, object, func } from 'prop-types';

import {
  startSetFaqPage,
  startSetFaqList,
  startSetFaqVote,
  startSetTreeList,
  startSetFaqSearch,
  startSetFaqGlossary,
  startSetLastUpdateList,
  startSetFaqRecommendation,
} from '../../actions/faq';
import { faqConstants } from '../../constants/faq';
import Layout from '../../components/Layout/Layout';
import Card from '../../components/Card/Card';
import FaqSearch from '../../components/Faq/FaqSearch';
import FaqContent from '../../components/Faq/FaqContent';
import FaqHeaderList from '../../components/Faq/FaqHeaderList';
import FaqLastUpdateBlock from '../../components/Faq/FaqLastUpdateBlock';
import FaqGlossary from '../../components/Faq/FaqGlossary';
import FaqRecommendation from '../../components/Faq/FaqRecommendation';
import FaqFeedback from '../../components/Faq/FaqFeedback';

class FaqPage extends Component {
  static propTypes = {
    tree: array.isRequired,
    page: object.isRequired,
    list: array.isRequired,
    glossary: object.isRequired,
    lastUpdate: array.isRequired,
    searchList: array.isRequired,
    recommendation: object.isRequired,
    startSetFaqVote: func.isRequired,
    startSetFaqList: func.isRequired,
    startSetTreeList: func.isRequired,
    startSetFaqPage: func.isRequired,
    startSetFaqSearch: func.isRequired,
    startSetFaqGlossary: func.isRequired,
    startSetLastUpdateList: func.isRequired,
    startSetFaqRecommendation: func.isRequired,
  };

  static defaultProps = {
    tree: [],
    page: {},
    list: [],
    glossary: {},
    lastUpdate: [],
    searchList: [],
    recommendation: {},
  };

  state = {
    parents: {},
    paths: {},
    tree: { loading: false },
    list: { loading: false },
    glossary: { loading: false },
    searchList: { loading: false },
    lastUpdate: { loading: false },
    recommendation: { loading: false },
    data: {
      q: '',
      comment: '',
    },
    page: {
      loading: false,
      currentPage: faqConstants.DEFAULT_PAGE,
    },

    loading: false,
    feedbackFormOpen: false,
    feedbackSent: false,
    feedbackSending: false,
  };

  componentDidMount() {
    window.scrollTo(0, 0);

    const { faqPath } = this.props.match.params;

    this.setState(() => ({
      recommendation: { loading: true },
      loading: true,
    }));

    this.props
      .startSetFaqList()
      .then((data) => this.getObjectPathId(data.list))
      .then(() => this.props.startSetTreeList())
      .then(({ tree }) => {
        const parents = this.buildParent(tree);
        return this.setState(() => ({ parents }));
      })
      .then(() => this.props.startSetFaqGlossary())
      .then(() => this.props.startSetLastUpdateList())
      .then(() => this.props.startSetFaqPage(this.getIdByPath(faqPath)))
      .then(() => this.reloadRecommendation())
      .then(() => {
        this.setState(() => ({ loading: false }));
      });
  }

  buildParent = (data = []) =>
    data.reduce((items, item) => {
      if (item.children && item.children.length > 0) {
        return { ...items, ...this.buildParent(item.children) };
      }

      const parents = Array.isArray(items[item.parent_id])
        ? { [item.parent_id]: [...items[item.parent_id], item.id] }
        : { [item.parent_id]: [item.id] };

      return { ...items, ...parents };
    }, {});

  random(min, max) {
    return (Math.random() * ((max ? max : min) - (max ? min : 0) + 1) + (max ? min : 0)) | 0;
  }

  getRecommendationId = () => {
    const { currentPage: id } = this.state.page;
    const { parents } = this.state;

    let section = [];

    Object.values(parents).forEach((item) => {
      if (item.includes(id)) {
        section = [...item];
      }
    });
    if (!section.length) {
      Object.keys(parents).forEach((pKey) => {
        if (id === +pKey) {
          section = parents[id];
        }
      });
    }
    if (section.length === 1) {
      return faqConstants.DEFAULT_PAGE;
    }
    section = section.filter((sec) => sec !== this.props.page.id);
    let randInt = this.random(0, section.length - 1);

    if (randInt === section.indexOf(this.props.page.id)) {
      return section[randInt + 1] || section[randInt - 1];
    }
    return section[randInt] || faqConstants.DEFAULT_PAGE + 1;
  };

  getObjectPathId = (data = []) => {
    const paths = data.reduce(
      (items, item) => ({ ...items, [item.path]: parseInt(item.id, 10) }),
      {},
    );

    this.setState(() => ({ paths }));
  };

  getIdByPath = (path) => {
    const { paths } = this.state;

    const currentPage = paths['faq/' + path] || faqConstants.DEFAULT_PAGE;
    this.setState((prevState) => ({
      page: {
        ...prevState.page,
        currentPage,
      },
    }));

    return currentPage;
  };

  reloadRecommendation = () => {
    this.setState(() => ({ recommendation: { loading: true } }));

    this.props.startSetFaqRecommendation(this.getRecommendationId()).then(() => {
      this.setState(() => ({ recommendation: { loading: false } }));
    });
  };

  onSearch = () => {
    const { q } = this.state.data;

    if (q) {
      this.props.startSetFaqSearch({ q });
    }
  };

  openFeedbackForm = () => {
    this.setState(() => ({ feedbackFormOpen: true }));
  };

  setVote = (params) => {
    const { currentPage: faqId } = this.state.page;

    this.setState(() => ({ feedbackSending: true }));

    this.props
      .startSetFaqVote(faqId, { yes: params, comment: this.state.data.comment })
      .then(() => this.props.startSetFaqPage(faqId))
      .then(() => {
        this.setState(() => ({
          feedbackSent: true,
          feedbackSending: false,
        }));
      });
  };

  onChange = (e) => {
    const { target } = e;

    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [target.name]: target.value,
      },
    }));
  };

  render() {
    const { tree, lastUpdate, page, glossary, recommendation, theme } = this.props;
    const { comment } = this.state.data;
    const { feedbackSent, feedbackSending, loading } = this.state;
    const recommendation_loading = this.state.recommendation.loading;

    return (
      <Layout formattedTitle="pages.faq.title" className="faq-page">
        <Layout.Col className="faq-top">
          <FaqSearch />
        </Layout.Col>
        <Layout.LeftCol className="left-col">
          <Card className={loading ? 'faq-page-item card-loading' : 'faq-page-item'}>
            <Card.Body>
              <FaqSearch />
              <FaqContent page={page} />
              {feedbackSent ? (
                <strong>
                  <FormattedMessage
                    id="faq.feedback.message.sent"
                    defaultMessage="Thanks for the feedback!"
                  />
                </strong>
              ) : (
                <FaqFeedback
                  sendFeedback={this.setVote}
                  openForm={this.openFeedbackForm}
                  changeCommentHandler={this.onChange}
                  comment={comment}
                  feedbackFormOpen={this.state.feedbackFormOpen}
                  loading={feedbackSending}
                />
              )}
            </Card.Body>
          </Card>
        </Layout.LeftCol>

        <Layout.RightCol className="right-col">
          <Card className="faq-header-list">
            <Card.Body>
              <p className="faq-header-list-title">
                <FormattedMessage id="faq.header" defaultMessage="Table of contents" />
              </p>
              <FaqHeaderList tree={tree} />
            </Card.Body>
          </Card>

          {recommendation && recommendation.id ? (
            <FaqRecommendation
              page={recommendation}
              loading={recommendation_loading}
              reload={this.reloadRecommendation}
            />
          ) : null}

          <Card className="faq-last-update">
            <Card.Body>
              <FaqLastUpdateBlock list={lastUpdate} />
            </Card.Body>
          </Card>

          <Card>
            <Card.Body>
              <FaqGlossary glossary={glossary} />
            </Card.Body>
          </Card>
        </Layout.RightCol>
      </Layout>
    );
  }
}

const mapStateToProps = ({ faq, webmaster }) => ({ ...faq, theme: webmaster.profile.theme });

const mapDispatchToProps = (dispatch) => ({
  startSetFaqVote: (faqId, params) => dispatch(startSetFaqVote(faqId, params)),
  startSetFaqList: () => dispatch(startSetFaqList()),
  startSetTreeList: () => dispatch(startSetTreeList()),
  startSetFaqPage: (faqId) => dispatch(startSetFaqPage(faqId)),
  startSetFaqSearch: (params) => dispatch(startSetFaqSearch(params)),
  startSetFaqGlossary: () => dispatch(startSetFaqGlossary()),
  startSetLastUpdateList: () => dispatch(startSetLastUpdateList()),
  startSetFaqRecommendation: (faqId) => dispatch(startSetFaqRecommendation(faqId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FaqPage);
